import {
  Box,
  styled,
  Typography,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import LayoutModal from '../../../LayoutModal';

const ImageGift = styled('img')(({ theme }) => ({
  width: theme.spacing(30),
  height: theme.spacing(30),
}));

const FirstTimeLoginModal = ({
  open = true,
  handleClose = () => {
    return;
  },
  route = '',
}) => {
  const theme = useTheme();
  const mdUp = useMediaQuery(theme.breakpoints.up('md'));
  return (
    <LayoutModal open={open} handleClose={handleClose}>
      <ImageGift src="/static/img/gift.gif" />
      <Typography
        sx={{ mt: 10, fontWeight: 700, color: 'secondary.neutral_40' }}
      >
        Your active plan is Free!
      </Typography>
      <Typography sx={{ mt: 2, color: 'secondary.neutral_40' }}>
        We upgraded your account to Free plan.
      </Typography>
    </LayoutModal>
  );
};
export default FirstTimeLoginModal;
